document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.js-fade-in, .fade-item, .js-fade-in-sp');

  if (!targets.length) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -10% 0px'
  });

  targets.forEach(el => observer.observe(el));
});

/* ------------------------------------------------------------------
   定期便（ハックルベリー定期購買）選択時に価格表示を切り替える
   - 「月1定期便」選択中：定期便の価格帯（例: ¥14,080〜¥15,840）
   - 「1回限り」選択中　：通常価格（¥17,600）
------------------------------------------------------------------- */
(() => {
  const WRAPPER_SELECTOR = '[data-subscription-price-wrapper]';

  const isSubscriptionSelected = (scope) => {
    const widget = scope.querySelector('.huckleberry-subscription-widget-container');
    if (!widget) return false;

    const radio = widget.querySelector('input[type="radio"][value="subscription"]');
    if (radio) return radio.checked;

    const sellingPlan = widget.querySelector('input[name="selling_plan"]');
    return !!(sellingPlan && sellingPlan.value);
  };

  const update = () => {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapper) => {
      const onetimePrice = wrapper.querySelector('[data-onetime-price]');
      const subscriptionPrice = wrapper.querySelector('[data-subscription-price-range]');
      if (!onetimePrice || !subscriptionPrice) return; // トップページ等（価格帯のみ表示）は対象外

      const scope = wrapper.closest('.product-info') || document;
      const isSubscription = isSubscriptionSelected(scope);

      onetimePrice.style.display = isSubscription ? 'none' : '';
      subscriptionPrice.style.display = isSubscription ? '' : 'none';
    });
  };

  let scheduled = false;
  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };

  const init = () => {
    if (!document.querySelector(WRAPPER_SELECTOR)) return;

    update();

    // 定期便/1回限りの切り替え
    document.addEventListener('change', scheduleUpdate);
    document.addEventListener('click', scheduleUpdate);

    // ウィジェットの描画完了時
    window.addEventListener('renderedSubscriptionWidget', scheduleUpdate);

    // ウィジェットの描画やバリアント変更による価格ブロックの差し替えに追従
    document.querySelectorAll('.product-info').forEach((productInfo) => {
      new MutationObserver(scheduleUpdate).observe(productInfo, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();